import { IContext } from "@src/context";
import "./index.css";

const SEARCH_RESULT_ROOT_ID = "search-result-root";

function setupSearchResult(context: IContext) {
  const searhResultRoot = document.getElementById(SEARCH_RESULT_ROOT_ID);

  if (searhResultRoot == null) {
    return;
  }

  Promise.all([import("react-dom/client"), import("./SearchResult")]).then(
    ([{ createRoot }, { default: SearchResult }]) => {
      const root = createRoot(searhResultRoot);
      root.render(<SearchResult context={context} />);
    }
  );
}

export { setupSearchResult };
